import React from 'react';
import { useTranslation } from 'react-i18next';
import { Star, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const WhySection = () => {
  const { t } = useTranslation();

  const handleHowItWorksClick = () => {
    const element = document.querySelector('#how-it-works');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0f0f0f] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-20 right-0 w-72 h-72 bg-amber-500/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-0 w-72 h-72 bg-teal-500/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Why HorseGO Section */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Left - Content */}
          <div>
            {/* Rating */}
            <div className="flex items-center gap-1 mb-6">
              {[...Array(5)].map((_, i) => (
                <Star key={`why-star-${i}`} className="w-6 h-6 fill-amber-500 text-amber-500" />
              ))}
              <span className="text-gray-400 ml-2">{t('whySection.trustedBy')}</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              {t('whySection.whyTitle')} <span className="text-amber-500">HorseGO</span>?
            </h2>

            <p className="text-gray-300 text-lg mb-6 leading-relaxed">
              {t('whySection.description1')}
            </p>

            <p className="text-gray-400 mb-8 leading-relaxed">
              {t('whySection.description2')}
            </p>

            <Button
              variant="outline"
              onClick={handleHowItWorksClick}
              className="border-2 border-amber-500 text-amber-500 hover:bg-amber-500 hover:text-black px-6 py-3 rounded-full transition-all duration-300"
              data-testid="how-it-works-btn"
            >
              {t('nav.howItWorks')}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>

          {/* Right - Image/Visual */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_equine-transport/artifacts/l5ktqxs2_Van.jpg"
                alt="Horse transportation"
                className="w-full h-[400px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              
              {/* Overlay stats */}
              <div className="absolute bottom-6 left-6 right-6">
                <div className="flex justify-between">
                  <div className="bg-black/50 backdrop-blur-md rounded-xl px-4 py-3">
                    <p className="text-amber-500 font-bold text-2xl">500+</p>
                    <p className="text-white text-sm">{t('whySection.transporters')}</p>
                  </div>
                  <div className="bg-black/50 backdrop-blur-md rounded-xl px-4 py-3">
                    <p className="text-amber-500 font-bold text-2xl">25+</p>
                    <p className="text-white text-sm">{t('whySection.cities')}</p>
                  </div>
                  <div className="bg-black/50 backdrop-blur-md rounded-xl px-4 py-3">
                    <p className="text-amber-500 font-bold text-2xl">10K+</p>
                    <p className="text-white text-sm">{t('whySection.trips')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Lift Service Section */}
      </div>
    </section>
  );
};

export default WhySection;
